import { render } from "./SimpleTable.vue?vue&type=template&id=13735990"
import script from "./SimpleTable.vue?vue&type=script&lang=ts"
export * from "./SimpleTable.vue?vue&type=script&lang=ts"
script.render = render

export default script